// Shared by src/sentryBrowser.ts (import.meta.env) and src/sentryServer.ts
// (process.env), so it imports nothing and works in both runtimes.
//
// Both used to trace at a flat 1.0, which spent the org's entire monthly
// spans quota 11 days into the Oct 2026 billing period. The baseline now
// matches npt-api's tracesSampler (src/sentry-sampler.ts there).
export const DEFAULT_TRACES_SAMPLE_RATE = 0.1;

/**
 * Resolve VITE_SENTRY_TRACES_SAMPLE_RATE, falling back to the default when it is unset, blank,
 * non-numeric or outside [0, 1]. An explicit 0 is honoured and turns tracing off.
 */
export const resolveTracesSampleRate = (raw: string | undefined, fallback = DEFAULT_TRACES_SAMPLE_RATE): number => {
   // Number('') is 0, not NaN, so a present-but-blank var would otherwise disable tracing.
   if (raw === undefined || raw === null || String(raw).trim() === '') return fallback;

   const parsed = Number(raw);
   if (!Number.isFinite(parsed) || parsed < 0 || parsed > 1) return fallback;
   return parsed;
};
